<template>
  <div v-if="localFootnotes && allFootnotes" style="margin-left: 2px;display:inline">
    <span v-for="(footnote, index) in localFootnotes" style="font-size: 8px; vertical-align: super; font-weight: lighter">{{ allFootnotes.indexOf(footnote) + 1 }}{{ index + 1 < localFootnotes.length ? ',' : '' }} </span>
  </div>
</template>
<script>
export default {
  name: 'footnotes',
  props: {
    allFootnotes: {
      type: Array,
    },
    localFootnotes: {
      type: Array,
    },
  },
}
</script>



// WEBPACK FOOTER //
// Footnotes.vue?4a39ad7a